import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import { defaultApplicantsData } from "../../../_utilities/defaultfieldsModel";
import {
  getUserDetails,
  GetUserId as getUserId,
  GetUserInfo,
} from "../../../_utilities/getUserInfo";
import ApplicantsFooter from "../../../components/ApplicantsFooter/ApplicantsFooter";
import Loading from "../../../components/Loader/Loading";
import {
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE_BYTES,
} from "../../../_utilities/constants";

const initalState = { data: null, message: "", isloader: true };

export const ApplicantsRenderData = (props) => {
  const [isUpload, setIsUpload] = useState(true);
  const [uploadFile, setUploadFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [sourced, setSourced] = useState("");
  const [imgList, setImgList] = useState([]);
  const [imgData, setImgData] = useState([]);
  const [sourceModelValues, setSourceModelValues] = useState([]);
  const [isEnableAssociateJob, setIsEnableAssociateJob] = useState(true);

  const customFieldsData = useSelector((state) => state.CustomFields.data);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [GetUserId, setUserId] = useState(null);
  const documentLimit = GetUserInfo()[0].bulkUpload || 25; // Default limit set to 25 if not specified in user info

  useEffect(() => {
    async function init() {
      // if (GetUserId === null) {
      let userId = getUserId();
      setUserId(userId);
      // dispatch(customFieldsAsync(userId));
      // }
    }
    init();
  }, []); //GetUserId

  useEffect(() => {
    if (props.input && Object.keys(props.input).length > 0) {
      const files = props.input.imgData || [];
      setImgData(files || []);
      setSourced(props.input.sourced || { id: "", name: "" });
      let tempImgNames = [];
      if (files.length !== 0) {
        for (let i = 0; i < files.length; i++) {
          let uniqueId = imgData.length + i;
          tempImgNames.push({ id: uniqueId, name: files[i].name });
        }
      }
      setImgList(tempImgNames);
    }
  }, [props.input]);

  // const bulkUploadResumeData = useSelector(store => store.BulkUploadResume.data);
  const bulkUploadResumeCode = useSelector(
    (store) => store.BulkUploadResume.code,
  );
  const uploadResumeData = useSelector((store) => store.UploadResume.data);
  const duplicateResume = useSelector((store) => store.UploadResume.code);
  const updateResumeData = useSelector((store) => store.UploadResume);
  const isDuplicats = useSelector((store) => store.UploadResume.isDuplicats);
  // const uploadResumemessage = useSelector(store => store.UploadResume.data);  //Applicant Added successfully

  const UploadImgHandler = async (type) => {
    if (imgList.length !== 0 && sourced !== "") {
      const userInfo = await getUserDetails();
      let userDetails = await GetUserInfo();
      // e.preventDefault()
      setUploadFile(imgData[0]);
      if (type === "Continue") {
        let newObject = {
          type: "AssociateJob",
          isBulk: imgData.length === 1 ? false : true,
          data: {
            sourced: sourced,
            imgData: imgData,
            userDetails: userDetails,
            userInfo: userInfo,
            GetUserId: GetUserId,
          },
        };
        props.onReceivechildProps(false, newObject);
      } else if (type === "Save") {
        setIsLoading(true);
        let formData = new FormData();
        for (let i = 0; i < imgData.length; i++) {
          formData.append("Resume", imgData[i]);
        }
        formData.append("customerId", GetUserId);
        formData.append("userId", userInfo.userId);
        if (imgData.length === 1) {
          dispatch(_ser.uploadResumeAsync(formData, true));
        } else {
          formData.append("userFirstName", userInfo.firstName);
          formData.append("userLastName", userInfo.lastName);
          formData.append("email", userInfo.email);
          formData.append("resumesourceId", sourced.id ? sourced.id : "");
          formData.append("resumesource", sourced.name ? sourced.name : "");
          formData.append("submittedBy", userInfo.id);
          formData.append("DbUserId", userInfo.id);
          formData.append("source", "ATS");
          dispatch(
            _ser.bulkUploadResumeAsync(formData, true, props.isAssociate),
          );
        }
      } else if (type === "Back") {
        props.onReceivechildProps(false, "Back");
      }
    } else {
      dispatch(
        updateSnackbar({ type: "error", message: "All fields are required" }),
      );
    }
  };

  useEffect(() => {
    if (bulkUploadResumeCode === 200) {
      setIsLoading(false);
      setIsUpload(false);
      dispatch(_ser.bulkUploadResumeStartReducer(initalState));
      props.onReceivechildProps(false, "close");
      // console.log(bulkUploadResumeData);
    } else {
      setIsLoading(false);
    }
  }, [bulkUploadResumeCode]);

  useEffect(() => {
    if (
      uploadResumeData !== null &&
      sourced !== "" &&
      uploadFile.length !== 0
    ) {
      setIsLoading(false);
      setIsUpload(false);
      let json = JSON.parse(JSON.stringify(uploadResumeData[0]));
      const url = props?.showCreateNew
        ? "/ats/layout/applicants/create-new"
        : "/ats/layout/applicants/create";
      navigate(url, {
        state: {
          applicant: json,
          sourceId: sourced,
          uploadfile: uploadFile,
          isAssociate: props.isAssociate,
          isduplicate: props.isduplicate,
        },
      });
      dispatch(_ser.uploadResumeStartReducer(initalState));
    }
  }, [uploadResumeData]);

  useEffect(() => {
    if (duplicateResume === 500 && updateResumeData.updatedata !== null) {
      setIsLoading(false);
      setIsUpload(true);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      let obj = {
        data: updateResumeData.updatedata[0],
        message: updateResumeData.message,
        id: updateResumeData.id,
        oldApplicantName: updateResumeData.oldApplicantName,
      };
      props.onManualPopup(false, sourced, uploadFile, obj);
    }
    if (duplicateResume === 500) {
      setIsLoading(false);
      setIsUpload(true);
      dispatch(_ser.uploadResumeStartReducer(initalState));
    } else if (duplicateResume === 400) {
      setIsLoading(false);
      setIsUpload(true);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      props.onManualPopup(true, sourced, uploadFile, null);
    }
    if (isDuplicats !== null) {
      setIsLoading(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      props.onManualPopup(false, null, null, { data: isDuplicats });
    }
  }, [duplicateResume, updateResumeData, isDuplicats]);

  const onRemoveItem = (item) => {
    let imgNames = JSON.parse(JSON.stringify(imgList));
    let ImgData = JSON.parse(JSON.stringify(imgData));
    let findIndex = imgNames.findIndex((x) => x.id === item.id);
    if (findIndex !== -1) {
      imgNames.splice(findIndex, 1);
      ImgData.splice(findIndex, 1);
      setImgList(imgNames);
    }
    // imgList.splice(parseInt(item.id), 1);
    // setImgList(imgList);
    imgData.splice(parseInt(findIndex), 1);
    setImgData(imgData);
  };

  const fileImgHandler = (event) => {
    let files = Array.from(event.target.files);
    var allowedExtensions = /(\.doc|\.docx|\.pdf)$/i;

    // Validate all file types
    const invalidFile = files.find(
      (file) => !allowedExtensions.test(file.name),
    );
    if (invalidFile) {
      dispatch(
        updateSnackbar({
          type: "error",
          message:
            "Invalid file format. Please upload a Doc, Pdf, or Docx file",
        }),
      );
      return;
    }

    // Check limit
    if (files.length + imgData.length > documentLimit) {
      dispatch(
        updateSnackbar({
          type: "error",
          message: `Reached maximum upload limit of ${documentLimit} files`,
        }),
      );
      return;
    }

    // Prepare new data
    let imgNames = [...imgList];
    let imgObj = [...imgData];
    let tempImgNames = [];
    let tempImgObj = [];

    for (let i = 0; i < files.length; i++) {
      if (files[i].size > MAX_FILE_SIZE_BYTES) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
          }),
        );
        continue;
      }
      let uniqueId = Date.now() + i;
      tempImgNames.push({ id: uniqueId, name: files[i].name });
      tempImgObj.push(files[i]);
    }

    imgNames.push(...tempImgNames);
    imgObj.push(...tempImgObj);

    setImgList(imgNames.slice(0, documentLimit));
    setImgData(imgObj.slice(0, documentLimit));
    event.target.value = "";
  };

  useEffect(() => {
    let defaultPostingModules = defaultApplicantsData.filter(
      (x) => x.moduleId.toString() === "2",
    );
    if (defaultPostingModules.length > 0) {
      defaultPostingModules.forEach((list) => {
        if (list.fieldName === "Source") {
          setSourceModelValues(list.customValues);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let overrideDefaultPostingFieldsData = data.filter(
        (x) => x.moduleId.toString() === "2" && x.fieldType === "default",
      );
      if (overrideDefaultPostingFieldsData.length > 0) {
        overrideDefaultPostingFieldsData.forEach((list) => {
          if (list.fieldName === "Source") {
            let updatedCustomValues = JSON.parse(list.customValues);
            let modifiedCustomValues = [];
            updatedCustomValues.forEach((list) => {
              if (
                list !== "Cloud Sourcing" &&
                list !== "Employee Portal" &&
                list !== "Vendor Sourcing" &&
                list !== "Job Board Portal"
              ) {
                modifiedCustomValues.push(list);
              }
            });
            setSourceModelValues(modifiedCustomValues);
          }
        });
      }
      // dispatch(customFieldsStartReducer({}));
    }
  }, [customFieldsData]);

  const onChangehandler = (value, type) => {
    if (type === "source") {
      let sourceIndex = sourceModelValues.findIndex((s) => s === value);
      if (sourceIndex !== -1) {
        let obj = { id: sourceIndex + 1, name: value };
        setSourced(obj);
      }
    }
  };

  const footerHandler = (id, type) => {
    UploadImgHandler(type);
  };

  return (
    <>
      <div>
        <FormControl fullWidth>
          <InputLabel className="boldSelectlabel" shrink={true}>
            Sourced from *
          </InputLabel>
          {/* <Select
                        value={props?.input?.sourced?.id ?? sourced?.id}
                        name="Sourced From"
                        autoComplete="off"
                        label="Sourced From*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                        onChange={(e) => onChangehandler(e, "source") }
                        style={{ width: "100%", height: "3.5rem", borderRadius: "4px" }}
                        className='sourcedfrominput'
                    >
                        {sourceModelValues.map((name, index) => (
                            <MenuItem className="selectOptions" key={name} value={(index + 1).toString()}>
                                {name}
                            </MenuItem>
                        ))}
                    </Select> */}
          <Autocomplete
            className='sourcedfrominput'
            id="controlled-demo"
            value={props?.input?.sourced?.name ?? sourced?.name}
            options={sourceModelValues}
            getOptionLabel={(option) => option ?? ""}
            disableClearable
            onChange={(e, value) => onChangehandler(value, "source")}
            renderInput={(params) => <TextField {...params} />}
          />
        </FormControl>
      </div>

      {isUpload === true ? (
        <div className="applicantsupload">
          <div className="Applicantuploadfileicon">
            {imgList.length === 0 && (
              <img
                src={process.env.PUBLIC_URL + "/assests/img/uploadBgIcon.svg"}
                alt=""
              />
            )}
          </div>
          <Button
            variant="contained"
            component="label"
            className="appuploadresume"
            disabled={imgList.length >= documentLimit}
          >
            <span>
              <b style={{ color: "var(--primary-bg-color)" }}>Upload</b>
              <b style={{ color: "#9E9E9E" }}> browse file to upload </b>
            </span>
            <input
              hidden
              type="file"
              id="fileId"
              multiple
              onChange={(e) => fileImgHandler(e)}
            />
          </Button>
          <p className="docsupporttext">
            Supported file formats: Doc, Pdf, Docx{" "}
          </p>
          {imgList.length > 0 ? (
            <>
              <ul className="filelistupload">
                {imgList &&
                  imgList.map((list) => {
                    return (
                      <li key={list.id}>
                        <p>{list.name}</p>
                        <span
                          className="closeImgbtn"
                          onClick={() => onRemoveItem(list)}
                        >
                          <DeleteOutlineIcon />
                        </span>
                      </li>
                    );
                  })}
              </ul>
              {props.isAssociate === null && (
                <div className="enableAssociateJob">
                  <p>
                    <Checkbox
                      checked={isEnableAssociateJob}
                      style={{ width: "30px", maxHeight: "24px" }}
                      onClick={() => {
                        setIsEnableAssociateJob(!isEnableAssociateJob);
                      }}
                    />
                  </p>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsEnableAssociateJob(!isEnableAssociateJob);
                    }}
                  >
                    Associate Job
                  </p>
                </div>
              )}
            </>
          ) : (
            ""
          )}
          {props.isAssociate !== null && (
            <div
              style={{
                textAlign: "right",
                marginTop: "12%",
                position: "relative",
                left: "40%",
              }}
            >
              <Button
                variant="text"
                type="button"
                className="addApplicantcancelBtn"
                onClick={() => {
                  props.onReceivechildProps(false, "close");
                }}
                size="small"
              >
                <Link
                  href="#"
                  style={{ color: "red", fontSize: "14px" }}
                  underline="always"
                >
                  {" "}
                  Cancel
                </Link>
              </Button>
              <Button
                type="button"
                variant="contained"
                size="small"
                className="saveBtn"
                onClick={(e) =>
                  UploadImgHandler(
                    props.isAssociate === null && isEnableAssociateJob === true
                      ? "Continue"
                      : "Save",
                  )
                }
              >
                {props.isAssociate === null &&
                isEnableAssociateJob === true &&
                imgList.length > 0
                  ? "Continue"
                  : "Save"}
              </Button>
            </div>
          )}

          {/* <div className="rightimgBox">
                        <img src={`${process.env.PUBLIC_URL}/assests/img/AddDocumentsIcon.svg`} alt="" />
                        </div> */}
          {isLoading === true ? <Loading /> : ""}
        </div>
      ) : (
        ""
      )}
      {props.isAssociate === null && (
        <div className="footer_btn">
          <ApplicantsFooter
            onReceiveProps={footerHandler}
            isEnableAssociateJob={isEnableAssociateJob}
            component={"addApplicant"}
          />
        </div>
      )}
    </>
  );
};
